import styled, { css } from 'styled-components';
import { space } from 'styled-system';
const Square = styled.button `
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  height: 48px;
  padding: 0;

  font-weight: 600;
  color: var(--color-on-background);
  background: var(--color-background);
  border: none;

  &:hover {
    background: #f3f3f3;
  }

  &:focus-visible {
    outline: var(--outline);
    z-index: 2;
  }

  & > i {
    margin: 0 -4px;
  }

  ${({ $today }) => $today &&
    css `
      padding-top: 8px;

      &::after {
        content: '';

        display: flex;
        width: 4px;
        height: 4px;
        margin-top: 4px;

        background: var(--color-selection);
      }
    `}

  ${({ $inRange }) => $inRange &&
    css `
      color: var(--color-on-surface);
      background: #fdf4e6;

      &:hover {
        background: #fdf4e6;
        border: solid 2px var(--color-selection);
      }
    `}


  ${({ selected }) => selected &&
    css `
      color: var(--color-on-selection);
      background: var(--color-selection);

      &:hover {
        background: var(--color-selection-hover);
        border: none;
      }

      &::after {
        background: var(--color-on-selection);
      }
    `}


  ${({ disabled }) => disabled &&
    css `
      color: var(--color-on-surface);
      background: repeating-linear-gradient(
        -45deg,
        var(--color-disabled) 2px 4px,
        var(--color-background) 4px 10.5px
      ) !important;

      cursor: not-allowed;

      &:hover {
        border: none;
      }
    `}

  ${({ $altDisabled }) => $altDisabled &&
    css `
      background: transparent !important;

      &:hover {
        background: transparent;
      }

      cursor: not-allowed;
    `}

  ${({ $readOnly }) => $readOnly &&
    css `
      &:hover {
        background: var(--color-background);
        cursor: default;
      }
    `}

  ${({ $gray, selected }) => $gray &&
    !selected &&
    css `
      color: var(--color-inactive);
    `}

  ${space}
`;
export default Square;
